import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NavigationItem } from '@app/core/types/navigation.interface';
import { MenuItemVerticalComponent } from '../menu-item/menu-item.component';
import { MenuCollapseComponent } from '../menu-collapse/menu-collapse.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-menu-group-vertical',
  imports: [MenuCollapseComponent, MenuItemVerticalComponent, TranslatePipe],
  template: `
    @if (!item()!.hidden) {
      @if (item()!.title) {
        <li class="nav-item coded-menu-caption">
          <label>{{ item()!.title | translate }}</label>
        </li>
      }
      @if (item()!.children && item()!.children.length > 0) {
        @for (items of item()!.children; track $index) {
          @if (items.type === 'collapsible') {
            <app-menu-collapse [item]="items" [parentRole]="item().role" />
          } @else if (items.type === 'item') {
            <app-menu-item [item]="items" [parentRole]="item().role" />
          }
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuGroupVerticalComponent {
  readonly item = input.required<NavigationItem>();
}
